
import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver} from '@/utils/baseUrl';

//左侧部门树
export async function getDeptRightTree(params) {
    return post(erpplatserver+'/systemtree/getDeptTree', params, true)
}
//部门树
export async function getDeptTree(params) {
    return post(erpplatserver+'/systemtree/getDeptTree', params, true)
}
// export async function getDeptTree(params) {
//     return post(oaserver+'/organize/getDeptTree', params, true)
// }
//客户列表
export async function getCustomerList(params) {
    return post(erpplatserver+'/systemtree/getCustomerList', params, true)
}
//yehesuan客户列表s
export async function getCAccCustomerList(params) {
    return post(erpplatserver+'/systemtree/getCAccCustomerList', params, true)
}
//公司角色
export async function getCompanyTree(params) {
    return post(erpplatserver+'/systemtree/getCompanyTree', params, true)
}
//产品树
export async function getProductTree(params) {
    return post(erpplatserver+'/systemtree/getProductTree', params, true)
}

//保存编辑激励
export async function saveAuthSet(params) {
    return post(erpserver+'/rightset/saveAuthSet ', params, true)
}
//删除激励
export async function delAuthSet (params) {
    return post(erpserver+'/rightset/delAuthSet  ', params, true)
}
// 激励列表
export async function getAuthSetList(params) {
    return post(erpserver+'/rightset/getAuthSetList', params, true)
}
//--审批-----------------------------------------------------
//审批列表
export async function getFlowuserSetList(params) {
    return post(erpserver+'/rightset/getFlowuserSetList', params, true)
}
//--岗位------------------------------------------------------------------
//岗位职级
export async function getPositionSetList(params) {
    return post(erpserver+'/rightset/getPositionSetList', params, true)
}
//职级列表
export async function getHeadShipList (params) {
    return post(erpplatserver+'/systemtree/getHeadShipList ', params, true)
}
//审批类型
export async function getAppFlowTypeList(params) {
    return post(erpplatserver+'/systemtree/getAppFlowTypeList', params, true)
}
//岗位列表
export async function getYwTypeList(params) {
    return post(erpplatserver+'/systemtree/getYwTypeList', params, true)
}
//岗位列表
export async function getPositionList(params) {
    return post(erpplatserver+'/systemtree/getPositionList', params, true)
}
//已选中
export async function getAuthPSetSubList(params) {
    return post(erpserver+'/rightset/getAuthPSetSubList', params, true)
}
//保存编辑岗位职级
export async function savePositionSet(params) {
    return post(erpserver+'/rightset/savePositionSet ', params, true)
}
//删除岗位职级
export async function delPositionSet  (params) {
    return post(erpserver+'/rightset/delPositionSet  ', params, true)
}
//获取类型
export async function getRightTypeList  (params) {
    return post(erpserver+'/rightset/getRightTypeList  ', params, true)
}
